/* eslint-disable @nx/enforce-module-boundaries */
import { SearchIcon } from '@mybridge/icons/Search';
import {
  CloseButton,
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
  useDisclosure,
} from '@mybridge/ui';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { forwardRef, useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';

export const DiskSearchToggle = forwardRef(
  ({ value, onChange, defaultValue, ...props }, ref) => {
    const disc = useDisclosure();
    const { t } = useTranslator();
    const [str, setStr] = useState(defaultValue);

    useEffect(() => {
      if (value !== str) {
        setStr(value);
      }
    }, [value]);

    const handleChange = (e) => {
      const newValue = e?.target?.value;
      setStr(newValue);
      onChange?.(newValue);
    };

    const handleClear = () => {
      setStr('');
      onChange?.(null);
      disc?.onClose();
    };

    return disc?.isOpen ? (
      <InputGroup maxW={isMobile ? "60" : "64"} alignItems="center">
        <Input
          autoFocus={!isMobile}
          h="40px"
          borderRadius="30px"
          placeholder={t('profileDetails.typeToSearch') || "Type to search..."}
          value={str}
          onChange={handleChange}
          pr={8}
          {...(props ?? {})}
        />
        <InputRightElement mt={-1}>
          <CloseButton
            onClick={handleClear}
            size={["sm", "md"]}
            width={isMobile ? "18px" : "20px"}
            height={isMobile ? "18px" : "20px"}
          />
        </InputRightElement>
      </InputGroup>
    ) : (
      <IconButton
        variant="secondary"
        onClick={() => disc?.onOpen()}
        borderRadius="full"
      >
        <SearchIcon />
      </IconButton>
    );
  }
);